import bemBlock from '@gik/core/utils/bemBlock';
import { Button, SvgIcon } from '@gik/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoverPhotoEditorDirection } from './CoverPhotoEditor';
import { translationKeys } from '@gik/inkind-page/i18n/en';

interface IInkindCoverUploadImageControlsProps {
  isSaving: boolean;
  onCancel(): void;
  onSave(): void;
  direction?: CoverPhotoEditorDirection;
}
export default function InkindCoverUploadImageControls({
  onCancel,
  onSave,
  isSaving,
  direction,
}: IInkindCoverUploadImageControlsProps) {
  const bem = bemBlock('inkind-cover-upload-controls');
  const { t } = useTranslation();
  return (
    <>
      {!isSaving && (
        <Button type="button" variant="secondary" circle className={bem('cancel')} onClick={onCancel}>
          <SvgIcon name="X" size="base" />
        </Button>
      )}
      <Button type="button" variant="secondary" className={bem('save')} loading={isSaving} onClick={onSave}>
        <SvgIcon name="Upload" size="base" />
        {t(translationKeys.PageHeaderSavePhoto)}
      </Button>
      {(direction === 'vertical' || direction === 'horizontal') && (
        <div className={bem('drag-hint', [{ horizontal: direction === 'horizontal' }])}>
          <SvgIcon name="DragDoubleArrow" set="gik-icons" size="base" />
          <span>Drag to position</span>
        </div>
      )}
    </>
  );
}
